import { z } from "zod"
import { LOOKUP_MODES } from "@/modules/admin/sasis-lookup/types/lookup-result-entry"

export const healthInsuranceCardNumberPattern = /^(80756|80438)\d{15}$/

export const SOCIAL_SECURITY_NUMBER_DIGIT_COUNT = 13

export const keepDigitsOnly = (value: string) => value.replace(/\D/g, "")

export const sasisLookupSchema = z
  .object({
    mode: z.enum(LOOKUP_MODES),
    healthInsuranceCardNumber: z.string(),
    nationalInsuranceNumber: z.string(),
    insureeNumber: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    dateOfBirth: z.date().optional(),
    socialSecurityNumber: z.string(),
  })
  // Only the fields of the chosen mode are checked, because the four modes share one form.
  .superRefine((values, context) => {
    switch (values.mode) {
      case "veka":
        if (!healthInsuranceCardNumberPattern.test(values.healthInsuranceCardNumber)) {
          context.addIssue({
            code: "custom",
            path: ["healthInsuranceCardNumber"],
            message: "admin.sasisLookup.veka.invalidFormat",
          })
        }
        return

      case "insureeNumber":
        if (!/^\d+$/.test(values.nationalInsuranceNumber.trim())) {
          context.addIssue({
            code: "custom",
            path: ["nationalInsuranceNumber"],
            message: "admin.sasisLookup.insureeNumber.invalidNationalInsuranceNumber",
          })
        }
        if (values.insureeNumber.trim().length === 0) {
          context.addIssue({
            code: "custom",
            path: ["insureeNumber"],
            message: "common.fieldErrorList.requiredField",
          })
        }
        return

      case "nameAndDateOfBirth":
        if (values.firstName.trim().length === 0) {
          context.addIssue({ code: "custom", path: ["firstName"], message: "common.fieldErrorList.requiredField" })
        }
        if (values.lastName.trim().length === 0) {
          context.addIssue({ code: "custom", path: ["lastName"], message: "common.fieldErrorList.requiredField" })
        }
        if (values.dateOfBirth === undefined) {
          context.addIssue({ code: "custom", path: ["dateOfBirth"], message: "common.fieldErrorList.requiredField" })
        }
        return

      case "ahv":
        if (keepDigitsOnly(values.socialSecurityNumber).length !== SOCIAL_SECURITY_NUMBER_DIGIT_COUNT) {
          context.addIssue({
            code: "custom",
            path: ["socialSecurityNumber"],
            message: "admin.sasisLookup.ahv.invalidFormat",
          })
        }
        return
    }
  })

export type SasisLookupSchema = z.infer<typeof sasisLookupSchema>
